import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import forms from 'constants/forms';
import useOutsideClick from 'utils/useOutsideClick';

const UpdatePatientStatusModal = ({ togglePopup, handleClick }) => {
  const ref = useRef();
  useOutsideClick(ref, () => togglePopup(false));
  const statusList = forms.patientStatuses;

  return (
    <div className="patient-status__modal" ref={ref}>
      {statusList.map(({ value, label }) => (
        <div
          className="patient-status__modal-item"
          key={value}
          onClick={() => {
            handleClick(value);
            togglePopup(false);
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

UpdatePatientStatusModal.propTypes = {
  togglePopup: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default UpdatePatientStatusModal;
